import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  fab: {
    position: 'fixed',
    // Stacked ABOVE goTopButton, which this shares a corner with. That button
    // is fixed at bottom 30 with a height of 40 and a zIndex of 2100 — nearly
    // double this one's — and panelRoutes mounts it on every panel route. It
    // appears as soon as the page is scrolled past 40px, which on a table or a
    // long form is immediately, and it then sits on top of this button and
    // takes its clicks. 30 + 40 + a 16px gap.
    bottom: 86,
    // Logical, not `right`. This panel renders right-to-left in Persian, and a
    // button pinned to the physical right lands over the content in RTL rather
    // than in the trailing corner where a floating action belongs.
    insetInlineEnd: theme.spacing(3),
    // Above the app bar and drawer, below the modals. The date-picker popup on
    // this panel uses 10000, so this deliberately sits under it: a floating
    // button must never cover an open overlay.
    zIndex: theme.zIndex.appBar + 1
  }
}))
